import graphqlHandlers from './graphql';
import restHandlers from './rest';

export default [...graphqlHandlers, ...restHandlers];
